/** Normalize wire shapes (verdict casing, status, pubkey) to canonical forms. */
import type { JudgmentState, Verdict } from "./types.js";

export function normalizeVerdict(raw: unknown): Verdict {
  if (raw === null || raw === undefined) return "No verdict";
  const v = String(raw).toUpperCase();
  if (v === "ALLOW" || v === "GREEN") return "ALLOW";
  if (v === "HOLD" || v === "YELLOW") return "HOLD";
  if (v === "BLOCK" || v === "RED") return "BLOCK";
  return "HOLD";
}

export function normalizeStatus(raw: unknown): JudgmentState {
  const s = String(raw ?? "").toLowerCase();
  if (s === "pending" || s === "answered" || s === "error") return s;
  return "error";
}

/** Wire pubkey may be a hex string, a Buffer/Uint8Array, or `{ data: [...] }`. */
export function pubkeyToHex(val: unknown): string {
  if (!val) return "";
  if (typeof val === "string") return val;
  if (val instanceof Uint8Array) return Buffer.from(val).toString("hex");
  if (typeof val === "object") {
    const data = (val as { data?: unknown }).data;
    if (Array.isArray(data)) return Buffer.from(data).toString("hex");
  }
  return "";
}
